// extracted by mini-css-extract-plugin
export default {"Terminals":"Terminals_Terminals__bHWRG","container":"Terminals_container__o+f23","swiperItem":"Terminals_swiperItem__yqG7q","content":"Terminals_content__ozmI4"};